<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50"
            >
              <h4 class="card-title">
                {{ $t("message.login_form.ecp_login") }}
              </h4>
            </div>

            <div class="card-body">
              <form action="#">
                <span :class="['bmd-form-group mb-2 d-block']">
                  <label for="ecp_type">{{
                    $t("message.login_form.ecp_type")
                  }}</label>
                  <select
                    id="ecp_type"
                    v-model="ecp_storage"
                    class="form-control"
                  >
                    <option value="NONE">
                      {{ $t("message.login_form.ecp_NONE") }}
                    </option>
                    <option value="PKCS12">
                      {{ $t("message.login_form.ecp_PKCS12") }}
                    </option>
                    <option value="AKKaztokenStore">
                      {{ $t("message.login_form.ecp_AKKaztokenStore") }}
                    </option>
                    <option value="AKKZIDCardStore">
                      {{ $t("message.login_form.ecp_AKKZIDCardStore") }}
                    </option>
                    <option value="AKEToken72KStore">EToken Java 72k</option>
                    <option value="AKJaCartaStore">AK JaCarta</option>
                  </select>
                </span>
                <div class="text-center mb-2 mt-4">
                  <button
                    :class="[
                      'btn btn-success btn-round',
                      loading ? 'pl-5' : '',
                    ]"
                    @click.prevent.stop="submitECP"
                  >
                    <div
                      class="loading my-1 loading-button"
                      v-if="loading"
                    ></div>
                    {{ $t("message.login_form.ecp_login") }}
                    <div class="ripple-container"></div>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import("./../../ncalayer");

var querystring = require("querystring");
export default {
  data() {
    return {
      ecp_storage: "NONE",
      pull: {
        customer_email: "",
        customer_password: "",
      },
      loading: false,
      rw2: {},
    };
  },
  methods: {
    submitECP() {
      this.loading = true;
      window.getKeyInfo(this.ecp_storage, "getKeyInfoBack");
    },
    submit() {
      this.loading = true;
      var bodyFormData = new FormData();
      bodyFormData.set("userName", "Fred");
      axios
        .post(window.base + "/account/login", querystring.stringify(this.pull))
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.$store.commit("login", { user: response.data.user });
            this.$router.push({ name: "home" });
          }
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          alert("Login " + error);
          this.loading = false;
        });
    },
  },
  mounted() {
    window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
    window.callback = null;

    window.webSocket.onopen = function (event) {
      console.log("Connection opened");
    };

    window.webSocket.onclose = function (event) {
      if (event.wasClean) {
        console.log("connection has been closed");
      } else {
        console.log("Connection error");
        openDialog();
      }
      console.log("Code: " + event.code + " Reason: " + event.reason);
    };

    window.webSocket.onmessage = function (event) {
      var result = JSON.parse(event.data);

      if (result != null) {
        var rw = {
          code: result["code"],
          message: result["message"],
          responseObject: result["responseObject"],
          getResult: function () {
            return this.result;
          },
          getMessage: function () {
            return this.message;
          },
          getResponseObject: function () {
            return this.responseObject;
          },
          getCode: function () {
            return this.code;
          },
        };
        this.rw2 = rw;
        if (window.callback != null) {
          window[window.callback](rw);
        }
      }
      // console.log(event);
    };
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
};
</script>
